export default "__VITE_ASSET__2bbf21f9__"